<template>
    <div class="donation-container">
		<div class="tit-box">
			<p>나두 기부증서</p>
			<h1>따뜻한 사랑을 <br/>나눠주셔서 감사해요</h1>
		</div>
		<div class="img-box">
			<object type="image/svg+xml" data="https://s3-ap-northeast-2.amazonaws.com/picture-master.greenatm.kr/app/donation-minti.svg" class = "image" alt="민티와 상차">
			</object>
		</div>
		<div class="innerContainer">
			<div class="content-box">
				<!-- 메인 이름 -->
				<div class="name-box">
					<div>
						<p class="omyu">{{userNm}} <em>님</em></p>
					</div>
				</div>
				<!-- 메인 이름 -->
				<div class="desc-box">
					<p>
						나눌수록 두 배 더 커지는<br/>
						나두 기부 캠페인에 참여해 주셔서 감사해요.<br/><br/>
						기부를 통해 디지털 격차를 줄이는 일, <br/>
						나아가 자원 재순환으로 중고폰에<br/>
						새로운 가치를 불어넣는 일,<br/>
						모두 
						<!-- 메인 이름 -->
						<b class="omyu">{{userNm}} <em>님</em></b>
						<!-- 메인 이름 -->
						의 참여가 있어 가능했어요.<br/><br/>
						나눠주신 따뜻한 사랑을 <br/>
						도움이 필요한 아이들을 위해 소중히 사용하겠습니다.
					</p>
					<!-- 날짜 -->
					<span>{{dntDay}}</span>
					<!-- 날짜 -->
				</div>
			</div>
		</div>
		<div class="collabor-box">
			<img src="@/assets/images/donation_collabor_logo.svg" alt="콜라보 로고">
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'

export default {
  name: 'DonateDetail',
  components: {
  },
  data: () => ({

    AppConfig: AppConfig,
    userNm: "",
    dntDay : ""
  }),
  computed: {

  },
  mounted() {
	
	this.userNm = decodeURIComponent(escape(atob(this.$route.query.userNm)))
	this.dntDay 		= this.$route.query.dntDay   
	
	
  },
  methods: {


  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/purchase/DonateDetail.vue